import fetchAPI from '../../../lib/utils/fetch-api'

export type EnumCollectionRow = {
  id: number
  name: string
  code: string
  module?: string | null
}

export async function resolveEnumCollectionIdByCode(code: string): Promise<number | null> {
  const resp = await fetchAPI('/api/enum-collections')
  const data = (resp?.data || []) as EnumCollectionRow[]
  const found = data.find(r => String(r?.code || '').toLowerCase() === String(code).toLowerCase())
  return found?.id ?? null
}
